module.exports = __webpack_public_path__ + "static/media/AAC.b50ffdad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/attachment-icons/AAC.svg
// module id = 1696
// module chunks = 17